export default "__VITE_ASSET__DzpER26K__"